﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import {loaderShow,loaderHide} from "./loader";
import redPin from "../images/icons/pin-red.svg";
import greyPin from "../images/icons/pin-grey.svg";
import emptyPin from "../images/icons/pin-empty.svg";
import halfPin from "../images/icons/pin-half.svg";
import defaultPin from "../images/icons/pin.svg";
import markerImage from "../images/icons/marker-e.svg";
import {getFadedMapOptions} from "./support/faded-map-options";


const findBranchForm = $("#findBranchForm");
let findBranchAutocomplete;
let findBranchAllowSubmit = false;

export function initializeFindBranchMap() {
    if (document.getElementById("find-branch-map")) {
        let findBranchMapHolder = $("#find-branch-map");
        let defaultMapLocation = {
            lat: findBranchMapHolder.data("lat"), lng: findBranchMapHolder.data("lng")
        };
        new google.maps.Map(findBranchMapHolder[0], getFadedMapOptions(defaultMapLocation));
    }
}

export function initializeMapSearch() {
    let locationSelect = document.getElementById('locationSearchInput');

    if (locationSelect) {
        findBranchAutocomplete = new google.maps.places.Autocomplete(locationSelect, {
            types: ['geocode'], componentRestrictions: {country: ['gb']}
        });
        findBranchAutocomplete.addListener('place_changed', setLocationSearchResult);
        locationSelect.addEventListener('keydown', function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                if (this.value.trim().length > 0) {
                    getFirstPrediction(this.value);
                }
            }
        });
    }
}

let previousInfoWindow;
export function initializeBranchFullMap() {
    if (document.getElementById("branch-full-map")) {

        let bounds = new google.maps.LatLngBounds();
        let markerDataList = $("#branch-full-map").data("marker-list");
        let mapCenter = $("#branch-full-map").data("map-center");
        let mapOptions = {
            center: {
                lat: mapCenter.Latitude, lng: mapCenter.Longitude
            }, disableDefaultUI: true
        };

        if (!markerDataList.length) {
            mapOptions.zoom = 14;
        }

        const map = new google.maps.Map(document.getElementById("branch-full-map"), mapOptions);

        markerDataList.forEach(function (item) {
            if (item.Index != null)//Temporary disable None Types
            {
                let markerIcon = {
                    url: item.BranchType == 2 ? redPin : item.BranchType == 4 ? greyPin : item.BranchType == 8 ? emptyPin : item.BranchType == 6 ? halfPin : defaultPin,
                    scaledSize: new google.maps.Size(28, 42)
                };

                let loc = new google.maps.LatLng(item.Latitude, item.Longitude);
                bounds.extend(loc);

                let marker = new google.maps.Marker({
                    position: loc, map, icon: markerIcon, label: {
                        text: (item.Index ?? "").toString(),
                        color: item.BranchType == 8 ? "#c00d0e" : "#fff",
                        className: "fs-14 fw-bold mt-n2"
                    },
                });

                marker.addListener("click", () => {
                    if (previousInfoWindow) {
                        previousInfoWindow.close();
                    }
                    let waiting = $("#branch-full-map");
                    loaderShow(waiting);
                    source = `/Branch/GetDetails?id=${item.Id}&index=${item.Index}`;
                    $.ajax({
                        url: source, type: 'GET', dataType: 'html', cache: true, success: function (data) {
                            let infowindow = new google.maps.InfoWindow({
                                content: data, closeBoxMargin: "10px",
                            });
                            infowindow.open({
                                anchor: marker, map, shouldFocus: false,
                            });
                            previousInfoWindow = infowindow;
                        }, error: function (error) {
                            console.error(error);
                        }, complete: function (event) {
                            loaderHide(waiting);
                        }
                    });

                });
            }

        });

        if (markerDataList.length) {
            map.fitBounds(bounds);
            map.panToBounds(bounds);
        }
    }
}

export function initializeBranchMap() {
    if (document.getElementById("branch-map")) {
        let markerPosition = $("#branch-map").data("map-center");
        const map = new google.maps.Map(document.getElementById("branch-map"), {
            zoom: 15, center: {
                lat: markerPosition.Latitude, lng: markerPosition.Longitude
            }, disableDefaultUI: true
        });

        new google.maps.Marker({
            position: {
                lat: markerPosition.Latitude, lng: markerPosition.Longitude
            }, map, title: "Elliotts", icon: markerImage
        });
    }
}

export function initiateBranchPage(){
    //Set Current Location
    $('[data-current-location]').on("click", setCurrentLocation);

    findBranchForm.on('submit', function (e) {
        if (findBranchAllowSubmit) {
            return;
        }
        e.preventDefault();
    });

    findBranchForm.find('input[type="checkbox"]').on("change", placeChangeHandler);
}



function setCurrentLocation(e) {
    e.preventDefault();
    let waiting = $("#findBranchForm").closest(".card");
    loaderShow(waiting);
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            findBranchForm.find('input[name="Latitude"]').val(position.coords.latitude);
            findBranchForm.find('input[name="Longitude"]').val(position.coords.longitude);
            placeChangeHandler();
            loaderHide(waiting);
        }, function () {
            handleLocationError(true);
            loaderHide(waiting);
        });
    } else {
        handleLocationError(false);
        loaderHide(waiting);
    }
}

function setLocationSearchResult() {
    let place = findBranchAutocomplete.getPlace();

    if (!place.geometry) {
        return;
    }
    let location = place.geometry.location;
    if (location) {
        findBranchForm.find('input[name="Latitude"]').val(location.lat());
        findBranchForm.find('input[name="Longitude"]').val(location.lng());
        placeChangeHandler();
    } else {
        findBranchForm.find('input[name="Latitude"]').val('');
        findBranchForm.find('input[name="Longitude"]').val('');
    }
}

function getFirstPrediction(inputValue) {
    const service = new google.maps.places.AutocompleteService({
        types: ['geocode'], componentRestrictions: {country: ["gb"]}
    });
    service.getQueryPredictions({input: inputValue + ', UK'}, function (predictions, status) {
        if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
            return;
        }

        let locationSelect = document.getElementById('locationSearchInput');
        locationSelect.value = predictions[0].description;
        let googlePlacesService = new google.maps.places.PlacesService(document.createElement('span'));
        googlePlacesService.getDetails({
            reference: predictions[0].reference
        }, function (details, status) {
            if (details) {
                let location = details.geometry.location;
                if (location) {
                    findBranchForm.find('input[name="Latitude"]').val(location.lat());
                    findBranchForm.find('input[name="Longitude"]').val(location.lng());
                    placeChangeHandler();
                } else {
                    findBranchForm.find('input[name="Latitude"]').val('');
                    findBranchForm.find('input[name="Longitude"]').val('');
                }
            }
        });
    });
}

function handleLocationError(browserHasGeolocation) {
    alert(browserHasGeolocation ? 'Error: Allow browser geolocation in order to search retailers by your current location.' : 'Error: Your browser doesn\'t support geolocation.');
}

function placeChangeHandler() {
    if (findBranchForm.length) {
        findBranchAllowSubmit = true;
        findBranchForm.submit();
    }
}